import { useEffect, useRef } from 'react';

// Keeps a grid's column header in view while the PAGE scrolls (.app-scroll, Note #113), for a grid
// that side-scrolls: its `overflow-x: auto` box is the header's scrollport, so CSS `sticky` would
// never move. The header is shifted down by however far the grid's top has gone under the page top.
export default function useStickyHead() {
  const ref = useRef(null);
  useEffect(() => {
    let frame = 0;
    const place = () => {
      frame = 0;
      const box = ref.current;
      const head = box && box.querySelector('thead');
      if (!head) return;
      const page = box.closest('.app-scroll');
      const top = page ? page.getBoundingClientRect().top : 0;
      const r = box.getBoundingClientRect();
      const shift = Math.max(0, Math.min(top - r.top, r.height - head.offsetHeight));
      head.style.transform = shift ? `translateY(${shift}px)` : '';
    };
    const onScroll = () => { if (!frame) frame = requestAnimationFrame(place); };
    window.addEventListener('scroll', onScroll, true);
    window.addEventListener('resize', onScroll);
    place();
    return () => {
      window.removeEventListener('scroll', onScroll, true);
      window.removeEventListener('resize', onScroll);
      if (frame) cancelAnimationFrame(frame);
    };
  }, []);
  return ref;
}
